/*
 * @Author: your name
 * @Date: 2021-02-01 11:56:13
 * @LastEditTime: 2021-08-18 10:29:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-purchase\components\two-steps-import\i18n.js
 */
const i18n = {
  'zh-CN': {
    step1: '第1步：',
    downloadFile: '点击下方图标，下载模板文件。',
    step2: '第2步：',
    importFile: '按模板格式编辑后，上传导入文件。',
    toHandIn: '提 交',
    theImport: '导入',
    incorrectDownloadTemplateParameters: '下载模板参数不正确',
    pleaseUploadTheImportFileFirst: '请先上传导入文件',
    importFailedPleaseTryAgainLater: '导入失败，请稍后重试！'
  },
  en: {
    step1: 'Step 1:',
    downloadFile: 'Click the icon below to download the template file.',
    step2: 'Step 2:',
    importFile: 'After editing in the template format, upload the import file.',
    toHandIn: 'Submit',
    theImport: 'Import',
    incorrectDownloadTemplateParameters: 'Incorrect download template parameters',
    pleaseUploadTheImportFileFirst: 'Please upload the import file first',
    importFailedPleaseTryAgainLater: '导入失败，请稍后重试！'
  },
  jp: {
  }
}
export default i18n
